import React from 'react';
import ReactDOM from 'react-dom';
import { getAppInfo, setHeartbeatState } from 'dooh-utils';
import { FitToWindow } from './FitToWindow';
import { ScreenRouter } from './Screen';
import { Store } from './state';
import GlobalStyle from './GlobalStyle';
import LoadingScreen from './preload/LoadingScreen';
import Preloader from './preload/Preloader';

export function renderScreens(
  screens,
  initState,
  convertHearbeatState = s => s,
  preloader = new Preloader()
) {
  const info = getAppInfo();

  if (info.tracking && info.tracking !== 'test') {
    document.body.setAttribute('data-cursor', 'hidden');
  }

  setHeartbeatState(convertHearbeatState(initState));
  const store = new Store(initState, convertHearbeatState);
  let resolvePromise = store => {};

  class App extends React.Component {
    state = {
      ...initState,
      loaded: preloader == null,
    };

    componentDidMount() {
      store.subscribe(this);
    }

    componentWillUnmount() {
      store.unsubscribe(this);
    }

    render() {
      return (
        <React.Fragment>
          {this.state.loaded
            ? this.fitToWindow(
                <ScreenRouter
                  screen={this.state.screen}
                  screens={screens}
                  hiddenBack={false}
                  update={store.update}
                  screenProps={Object.assign(
                    {
                      update: store.update,
                      info: info,
                    },
                    this.state
                  )}
                />,
                'App'
              )
            : this.fitToWindow(
                <LoadingScreen
                  onDone={this.doneLoading}
                  preloader={preloader}
                />,
                'Loading'
              )}
          <GlobalStyle />
          {preloader.getFontStyle()}
          {this.state.style}
        </React.Fragment>
      );
    }

    doneLoading = () => {
      this.setState({ loaded: true });
      resolvePromise(store);
    };

    fitToWindow(elem, className) {
      const s = this.state;

      return (
        <FitToWindow
          width={s.width || 1080}
          height={s.height || 1920}
          maxWidth={s.maxWidth}
          minWidth={s.minWidth}
          maxHeight={s.maxHeight}
          minHeight={s.minHeight}
          fit={s.fit == null ? true : s.fit}
          fitWidth={s.fitWidth == null ? false : s.fitWidth}
          centerVertical={s.centerVertical == null ? false : s.centerVertical}
          centerHorizontal={
            s.centerHorizontal == null ? false : s.centerHorizontal
          }
          onChange={s => store.update({ transform: s })}
          className={className}
        >
          {elem}
        </FitToWindow>
      );
    }
  }

  ReactDOM.render(<App />, document.getElementById('root'));

  return new Promise((resolve, reject) => {
    resolvePromise = resolve;
  });
}
